import "../../scss/pages/test-result-details.scss";

document.addEventListener("DOMContentLoaded", function () {
  import("bootstrap/js/dist/tooltip")
    .then((module) => {
      const Tooltip = module.default;

      const tooltipElements = document.querySelectorAll(".tooltip-button, [data-bs-toggle='tooltip']");

      tooltipElements.forEach((element) => {
        Tooltip.getOrCreateInstance(element, {
          html: true,
          boundary: "window",
          container: "body",
          trigger: "hover focus",
        });
      });
    })
    .catch((error) => {
      console.error("Error loading module:", error);
    });
});